import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes
 * Combines clsx for conditional classes with tailwind-merge to handle conflicts
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Formats a full name with an optional professional title
 * @example formatFullName('Juan Pérez', 'Lcdo.') // "Lcdo. Juan Pérez"
 * @example formatFullName('Juan Pérez') // "Juan Pérez"
 */
export function formatFullName(name: string, title?: string | null): string {
  if (!title) return name;
  return `${title} ${name}`;
}
